var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { SliceSidebarSectionLayout } from './slice-sidebar-section-layout';
import { IndicatorGroupsRenderer } from './indicator-groups-renderer';
import { indicatorGroupsWithResults } from '../utils/indicator-groups-with-results';
import { ContentNode } from './content-node';
var cls = classNames('slice-indicator-groups-sidebar-section');
export var SliceIndicatorGroupsSidebarDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n  "], ["\n    border-bottom: 1px solid ", ";\n  "])), theme.COLOR('canvas'))
});
var ContentStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SliceIndicatorGroupsSidebarSection',
  Container: styled(SliceSidebarSectionLayout)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Content: styled(ContentNode)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var SliceIndicatorGroupsSidebar = function (props) {
  var componentProps = useComponentProps(My.NAME, SliceIndicatorGroupsSidebarDefaultProps, props);
  var className = componentProps.className,
    entity = componentProps.entity;
  var items = indicatorGroupsWithResults(entity.indicatorGroups);
  if (!items.length) {
    return null;
  }
  return React.createElement(My.Container, {
    entity: entity,
    className: cls.name(className)
  }, React.createElement(My.Body, null, React.createElement(IndicatorGroupsRenderer, {
    items: entity.indicatorGroups
  })));
};
SliceIndicatorGroupsSidebar.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;